import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./store/index";
import { PrimeReactProvider } from "primereact/api";
import { ToastContextProvider } from "./components/Common/ReactToaster";

const getId: any = document.getElementById("root");
const root = ReactDOM.createRoot(getId);
root.render(
  <Provider store={configureStore({})}>
    <BrowserRouter>
      <PrimeReactProvider>
        <ToastContextProvider>
          <App />
        </ToastContextProvider>
      </PrimeReactProvider>
    </BrowserRouter>
  </Provider>
);
